export const home = {
  hero: {
    titleLine1: 'Find',
    titleLine2: 'Live',
    titleLine3: 'Talent',
    description: 'The most complete directory of musicians, soloists, and bands for weddings, corporate events, private parties, and galas in Las Vegas.',
    searchPlaceholder: 'Search by artist, genre, or event...',
    exploreArtists: 'Explore Artists',
    statArtists: '200+ Artists',
    statCategories: '7 Categories',
    statLocation: 'Las Vegas',
    sidebarTitle: 'From intimate soloists to full bands, find the perfect sound for your special event. Over 200 verified talents in Las Vegas.',
    card1Title: 'Soloists & Duos',
    card1Subtitle: 'For intimate events',
    card2Title: 'Trios & Quartets',
    card2Subtitle: 'For elegant celebrations',
    card3Title: 'Full Bands',
    card3Subtitle: 'For memorable events',
    location: 'Las Vegas, Nevada',
    locationSubtitle: 'Live music talent',
  },
  categories: {
    title: 'Formations',
    titleLine2: 'for Every',
    titleLine3: 'Event',
    description: 'From an intimate soloist to a full band, find the perfect musical formation for your celebration.',
    viewAll: 'View all categories',
  },
  eventTypes: {
    label: 'Event Types',
    title: 'The Perfect Music for Every Occasion',
  },
  fullBands: {
    label: 'Full Bands',
    titleLine1: 'Full',
    titleLine2: 'Formations',
    titleLine3: 'for Grand',
    titleLine4: 'Events',
    description: 'When your event needs energy and presence, a full band transforms any space into a memorable stage. From quintets to bands of 10+ musicians.',
    description2: 'Our talents have played at the most prestigious venues in Las Vegas, from luxury hotels to convention halls.',
    cta: 'Discover Bands',
  },
  featuredArtists: {
    label: 'Featured Artists',
    title: 'Talent that',
    titleLine2: 'Conquers Stages',
    viewAll: 'View all artists',
  },
  cta: {
    title: 'Find Your',
    titleLine2: 'Ideal Talent',
    description: 'Whether an intimate wedding or a corporate gala, we have the perfect artist to make your event an unforgettable experience.',
    button: 'Browse the Directory',
  },
};

export default home;